var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoyalty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F4633A",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 20C33.3337 21.9334 32.7603 23.7067 31.7737 25.1867C30.3337 27.32 28.0537 28.8267 25.4003 29.2134C24.947 29.2934 24.4803 29.3334 24.0003 29.3334C23.5203 29.3334 23.0537 29.2934 22.6003 29.2134C19.947 28.8267 17.667 27.32 16.227 25.1867C15.2403 23.7067 14.667 21.9334 14.667 20C14.667 14.84 18.8403 10.6667 24.0003 10.6667C29.1603 10.6667 33.3337 14.84 33.3337 20Z",
    fill: "#F4633A",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3338 32.6267L34.1338 33.1467C33.6404 33.2667 33.2538 33.64 33.1471 34.1334L32.6804 36.0934C32.4271 37.16 31.0671 37.48 30.3604 36.64L24.0004 29.3334L17.6404 36.6533C16.9338 37.4933 15.5738 37.1733 15.3204 36.1067L14.8538 34.1467C14.7338 33.6533 14.3471 33.2667 13.8671 33.16L11.6671 32.64C10.6538 32.4 10.2938 31.1333 11.0271 30.4L16.2271 25.2C17.6671 27.3333 19.9471 28.84 22.6004 29.2267C23.0538 29.3067 23.5204 29.3467 24.0004 29.3467C24.4804 29.3467 24.9471 29.3067 25.4004 29.2267C28.0538 28.84 30.3338 27.3333 31.7738 25.2L36.9738 30.4C37.7071 31.12 37.3471 32.3867 36.3338 32.6267Z",
    fill: "#F4633A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7736 15.9733L25.5603 17.5466C25.667 17.76 25.947 17.9733 26.2003 18.0133L27.627 18.2533C28.5336 18.4 28.747 19.0666 28.0936 19.72L26.987 20.8266C26.8003 21.0133 26.6936 21.3733 26.7603 21.64L27.0803 23.0133C27.3336 24.0933 26.7603 24.52 25.8003 23.9466L24.467 23.16C24.227 23.0133 23.827 23.0133 23.587 23.16L22.2536 23.9466C21.2936 24.5066 20.7203 24.0933 20.9736 23.0133L21.2936 21.64C21.347 21.3866 21.2536 21.0133 21.067 20.8266L19.9603 19.72C19.307 19.0666 19.5203 18.4133 20.427 18.2533L21.8536 18.0133C22.0936 17.9733 22.3736 17.76 22.4803 17.5466L23.267 15.9733C23.6536 15.12 24.347 15.12 24.7736 15.9733Z",
    fill: "#F4633A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.47fd15b97bf5112dac1138b54e53cace.svg";
export { ForwardRef as ReactComponent };